export type BulkChannel = "sms" | "email";

export type BulkLead = {
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  phone?: string | null;
  sms_consent?: boolean | null;
  sms_opt_out?: boolean | null;
  email_unsubscribed?: boolean | null;
  do_not_contact?: boolean | null;
};

const EASTERN = "America/New_York";

/** 8pm–8am Eastern. 8:00am is outside quiet hours. 8:00pm is inside. */
export function isQuietHours(date: Date, timeZone: string = EASTERN): boolean {
  const hourText = new Intl.DateTimeFormat("en-US", {
    timeZone,
    hour: "numeric",
    hourCycle: "h23",
  }).format(date);
  let hour = Number(hourText);
  if (hour === 24) hour = 0;
  return hour >= 20 || hour < 8;
}

/**
 * Why a bulk message must not go to this lead, or null when it may.
 * Quiet hours apply only to texts. A one-off text from the lead's page is separate.
 */
export function bulkSkipReason(
  lead: BulkLead,
  channel: BulkChannel,
  now: Date,
): string | null {
  if (lead.do_not_contact) return "Do not contact";
  if (channel === "email") {
    if (lead.email_unsubscribed) return "Unsubscribed";
    if (!lead.email) return "No email";
    return null;
  }
  if (lead.sms_opt_out) return "Opted out";
  if (!lead.sms_consent) return "Has not agreed to texts";
  if (!lead.phone) return "No phone";
  if (isQuietHours(now)) return "Quiet hours (8pm–8am Eastern)";
  return null;
}
